export default __webpack_public_path__ + "static/media/scan-qr.961310d5.gif";